import React from "react";

const FieldLabel = ({ as: Component = "div", className = "", children, ...props }) => {
  return (
    <Component className={`text-xs panel-text-secondary ${className}`.trim()} {...props}>
      {children}
    </Component>
  );
};

export default FieldLabel;
